module.exports = __webpack_public_path__ + "img/logo.39ab4928.jpg";